<div class="rs-panel-flex">
  <div class="panel rs-bg-grey1">
    <div class="small-only-text-center">
      <div
        class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
      ></div>
    </div>
    <div class="rs-flex-row">
      <div class="rs-flex-columns small-6">
        <div>
          <div
            class="panel rs-inline-block rs-wd-s8 rs-wd-m11 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading text-center"
          ></div>
        </div>
        <div>
          <div
            class="panel rs-inline-block rs-wd-s5 rs-wd-m7 rs-h-s2 rs-no-padding rs-margin-bottom-1 rs-bg-grey4 rs-anim-loading text-center"
          ></div>
        </div>
      </div>
      <div class="rs-flex-columns small-6">
        <div class="text-right">
          <div
            class="panel rs-inline-block rs-wd-s8 rs-wd-m11 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading text-center"
          ></div>
        </div>
        <div class="text-right">
          <div
            class="panel rs-inline-block rs-wd-s5 rs-wd-m7 rs-h-s2 rs-no-padding rs-margin-bottom-1 rs-bg-grey4 rs-anim-loading text-center"
          ></div>
        </div>
      </div>
    </div>
    <div
      class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
    ></div>
    <div
      class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
    ></div>
    <div
      class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
    ></div>

    <div class="text-center medium-text-right">
      <div
        class="panel rs-inline-block rs-wd-s10 rs-h-s3 rs-h-m2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
      ></div>
    </div>
  </div>
</div>
